import React from 'react';

const HelpMeChooseCross = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="12" fill="#C9CCD4"/>
      <path d="M9 9L14.9998 14.9998M15 9L9.00018 14.9998M12 12H12.008" stroke="#393949" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>

  );
};

export default HelpMeChooseCross;